import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import { useMutation } from '@tanstack/react-query';
import { getErrorCode, getErrorStatusCode } from "../../../../api/api-response";
import { RestEndpoints } from "../../../../api/endpoints";
import { getInstanceMultipartFormData } from "../../../../utils/rest";
import { IPostalsResultModel } from "../../models/routing-assignment/cfm-product-routing-assignment.model";

const uploadPostalsForCreateAssignments = async (file: File): Promise<string[]> => {
  const form = new FormData();
  form.append("file", file);
  const result = await getInstanceMultipartFormData().post<IPostalsResultModel>(
    RestEndpoints.UploadPostalsForCreateAssignments,
    form,
  );
  return result.data.postals;
};

export const useUploadPostalsForCreateAssignments = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();

  return useMutation({
    mutationFn: ({ file }: { file: File }) => uploadPostalsForCreateAssignments(file),

    onError: (error) => {
      const errorMsg = getErrorCode(error);
      const errorCode = getErrorStatusCode(error);
      enqueueSnackbar(t("general.error_occurred", { errorCode, errorMsg }), { variant: "error" });
    },
  });
};
